import _ from 'lodash'
import L3TitleText from '../l3/L3TitleText'
import { useConceptStatusValidity } from '../../../redux/selectConceptStatus2'
import { useConcept, useConceptActivation } from '../../../redux/selectConcept'
import { ConceptStatusValidityInfo } from '@fusion-advantage/formlib'

interface L4TitleLabelProps {
	cid: string
	title?: string
}

const L4TitleLabel = ({cid, title}: L4TitleLabelProps) => {
	const concept = useConcept(cid)
	const validity = useConceptStatusValidity(cid)
	const activation = useConceptActivation(cid)
	const validityInfo = validity ? new ConceptStatusValidityInfo(validity) : null

	return (
		<L3TitleText concept={concept} activation={activation} validity={validityInfo} title={title} />
	)
}

export default L4TitleLabel
